// Copy helpers the design names: fractions against a limit, times.

export function fraction(used: number, count: number): string {
  return `${used} of ${count}`;
}

/** A count against its pool: "3 of 20", or the bare count where no limit applies. */
export function poolText(pool: { used: number; count: number; unlimited: boolean } | undefined, fallback = 'unknown'): string {
  if (!pool) return fallback;
  return pool.unlimited ? String(pool.used) : fraction(pool.used, pool.count);
}

/** A file's size in MB to a tenth: "128.6 MB". */
export function megabytes(bytes: bigint | number): string {
  return `${(Number(bytes) / (1024 * 1024)).toFixed(1)} MB`;
}

export function when(ts: { seconds: bigint } | undefined, opts: { relative?: boolean } = {}): string {
  if (!ts) return '';
  const d = new Date(Number(ts.seconds) * 1000);
  if (opts.relative) {
    const mins = Math.round((Date.now() - d.getTime()) / 60000);
    if (mins < 1) return 'just now';
    if (mins < 60) return `${mins} min ago`;
    const h = Math.floor(mins / 60);
    if (h < 48) return `${h} h ago`;
    return `${Math.floor(h / 24)} d ago`;
  }
  return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

/** A day without its time: "Oct 12, 2026". */
export function day(ts: { seconds: bigint } | undefined): string {
  return ts ? new Date(Number(ts.seconds) * 1000).toLocaleDateString(undefined, { dateStyle: 'medium' }) : '';
}

/**
 * A date field's YYYY-MM-DD as the first or the last moment of that day in the
 * person's own time zone. `new Date('2026-03-05')` would be midnight UTC,
 * which is the evening before west of Greenwich.
 */
export function localDay(value: string, edge: 'start' | 'end'): Date | undefined {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!m) return undefined;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  return edge === 'start' ? new Date(y, mo - 1, d) : new Date(y, mo - 1, d, 23, 59, 59, 999);
}
